const pattern = /((https?:\/\/)[-a-zA-Z0-9_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)\.(?:jpg|jpeg|gif|png|heic|dng)\b(?:\S*[^ ,.:;<>(){}\[\]\n]){0,1})/i;

export default pattern;